import { apiAuth, apiDownloadAuth } from "./base";

export function getAllTickets(params) {
  let api = apiAuth();
  return api.get(`v1/tickets`, { params });
}

export function createTicket(data) {
  let api = apiAuth();
  return api.post(`v1/tickets`, data);
}

export function getTicketById(id) {
  let api = apiAuth();
  return api.get(`v1/tickets/${id}`);
}

export function createTikcetDetail(id, data) {
  let api = apiAuth();
  return api.post(`v1/tickets/${id}/details`, data);
}

export function downloadTickets(params = {}) {
  let api =  apiDownloadAuth();
  return api.get("v1/tickets/export/xlsx", {params});
}

export function getAssignableUsers(params) {
  let api = apiAuth();
  return api.get(`v1/tickets/assignable-users`, { params });
}

export function assignTicket(ticketUUID, data) {
  let api = apiAuth();
  return api.put(`v1/tickets/${ticketUUID}/assign`, data);
}

export function getTroubleshootReferenceLocations(params) {
  let api = apiAuth();
  return api.get(`v1/tickets/troubleshoot-references/locations`, { params });
}

export function getTroubleshootReferenceCauses(params) {
  let api = apiAuth();
  return api.get(`v1/tickets/troubleshoot-references/causes`, { params });
}

export function getTroubleshootReferenceResolutions(params) {
  let api = apiAuth();
  return api.get(`v1/tickets/troubleshoot-references/resolutions`, { params });
}